var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('sidebar.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: {name: 'risk_manager.dashboard'}
        }}}),_c('sidebar-item',{attrs:{"material":true,"link":{
          name: _vm.$t('sidebar.users'),
          icon: 'group',
          path: {name: 'risk_manager.user'}
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }